/**
 * 1px Linie. Auf dunkel rgba(255,255,255,.12), auf hell --paper-200.
 * Statt Card-Outlines.
 */

interface HairlineProps {
  orientation?: "horizontal" | "vertical";
  /** "presenter" | "light" — wenn nicht gesetzt, nutzt CSS-Variable die ggf.
   *  vom html.skin-* gesetzt wird. */
  skin?: "presenter" | "light";
  className?: string;
}

export function Hairline({
  orientation = "horizontal",
  skin,
  className,
}: HairlineProps) {
  const color =
    skin === "light"
      ? "var(--paper-200)"
      : skin === "presenter"
        ? "rgba(255,255,255,0.12)"
        : "var(--beacon-hairline, rgba(255,255,255,0.12))";

  const style: React.CSSProperties =
    orientation === "vertical"
      ? { width: 1, alignSelf: "stretch", background: color }
      : { height: 1, width: "100%", background: color };

  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={`beacon-hairline${className ? " " + className : ""}`}
      style={style}
    />
  );
}
